<template>
  <div class="live-radio">
    <div class="live-radio__flex">
      <div class="live-radio__flex__row">
        <div class="live-radio__flex__row__item">
          <div class="live-radio__flex__player">
            <AppStreamPlayer label="STEGI 1"
                             :title="playingNowTitle1"
                             :url="channelUrl1"
                             :volume="volumeAudio"
                             :mute="muted"
            />
          </div>
        </div>
        <div class="live-radio__flex__row__item">
          <div class="live-radio__flex__player--channel-2">
            <AppStreamPlayer label="STEGI 2"
                             :title="playingNowTitle2"
                             :url="channelUrl2"
                             :volume="volumeAudio"
                             :mute="muted"
            />
          </div>
        </div>
        <div class="live-radio__flex__row__item small">
          <div class="live-radio__flex__player--channel-3">
            <AppStreamPlayer label="STEGI 3"
                             :title="playingNowTitle3"
                             :url="channelUrl3"
                             :volume="volumeAudio"
                             :mute="muted"
            />
          </div>
        </div>
      </div>
      <div class="live-radio__flex__config">
        <button
          type="button"
          class="stream-info-toggle"
          :class="{ open: isLiveInfoOpen }"
          @click="liveStramDropdown()"
        >
          <ArrowIcon />
        </button>
        <div class="volume-button"
             @mouseenter="volumeOpen = true"
             @mouseleave="volumeOpen = false"
        >
          <button class="sound-button"
                  :class="{ muted: muted }"
                  @click="muted = !muted"
          >
            <SoundIcon v-if="!muted" />
            <SoundIconMute v-else />
          </button>
          <div class="volume-slider" :class="{expanded: volumeOpen}">
            <input v-model="volume"
                   type="range"
                   min="0"
                   max="100"
                   @input="volumeChange"
            />
          </div>
        </div>
        <button v-b-toggle="mobileNavcollapseId" class="search-button">
          <SearchIcon v-if="!searchCollapseOpen" />
          <IconClose v-else />
        </button>
      </div>
    </div>
    <Transition name="slide" mode="out-in">
      <PlayerSoundCloud v-if="isSoundcloud" />
    </Transition>
    <Transition name="slide" mode="out-in">
      <PlayerMixcloud v-if="isMixcloud" />
    </Transition>
  </div>
</template>
<script>
import {mapGetters, mapState} from 'vuex';
import ArrowIcon from '@/components/svg/ArrowIcon.vue';
import SearchIcon from '@/components/svg/SearchIcon.vue';
import SoundIcon from '@/components/svg/SoundIcon.vue';
import SoundIconMute from '@/components/svg/SoundIconMute.vue';
import IconClose from '@/components/svg/IconClose.vue';
import PlayerSoundCloud from "@/components/players/SoundcloudPlayer/PlayerSoundCloud.vue";
import PlayerMixcloud from "@/components/players/MixcloudPlayer/PlayerMixcloud.vue";
import AppStreamPlayer from "@/components/header/AppStreamPlayer.vue";

export default {
  name: 'AppLiveStream',
  components: {
    AppStreamPlayer,
    PlayerMixcloud,
    PlayerSoundCloud,
    ArrowIcon,
    SearchIcon,
    SoundIcon,
    IconClose,
    SoundIconMute
  },
  data() {
    return {
      mobileNavcollapseId: 'collapse-search',
      volumeOpen: false,
      mobileMenuOpen: false,
      muted: false,
      searchCollapseOpen: false,
      volume: 50,
      volumeAudio: this.volume * 0.01,
      channelUrl1:
          'https://movementathens.out.airtime.pro/movementathens_a?_ga=2.221863196.549192854.1604689934-1315503358.1602963392',
      channelUrl3:
          'https://movementathens2.out.airtime.pro/movementathens2_a?_ga=2.158636346.1472607981.1624423442-919228124.1624423442',
      channelUrl2:
          'https://stegiradio3.out.airtime.pro/stegiradio3_a?_ga=2.25876159.389710742.1727521963-1359830390.1725456003'
    };
  },
  computed: {
    ...mapGetters({
      playingNowTitle1: 'getLiveStreamTitle1',
      playingNowTitle2: 'getLiveStreamTitle2',
      playingNowTitle3: 'getLiveStreamTitle3'
    }),
    ...mapState({
      isLiveInfoOpen: state => state.liveStreamInfoState,
      isSoundcloud: state => state.audioPlayer.provider === 'SOUNDCLOUD',
      isMixcloud: state => state.audioPlayer.provider === 'MIXCLOUD',
    })
  },
  mounted() {
    this.liveChannel1 = this.$refs.liveChannel1;
    this.liveChannel2 = this.$refs.liveChannel2;
    this.getPlayingNow();
    this.listenMobileMenuCollapse();
    // every one hour
    setInterval(() => {
      this.getPlayingNow();
    }, 60000);
  },

  methods: {
    listenMobileMenuCollapse() {
      this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
        if (collapseId === 'collapse-mobile') {
          this.mobileMenuOpen = isJustShown;
        }
        if (collapseId === 'collapse-search') {
          this.searchCollapseOpen = isJustShown;
        }
      });
    },
    liveStramDropdown() {
      // eslint-disable-next-line vue/custom-event-name-casing
      if (this.mobileMenuOpen) this.$root.$emit('bv::toggle::collapse', 'collapse-mobile');
      // eslint-disable-next-line vue/custom-event-name-casing
      if (this.searchCollapseOpen) this.$root.$emit('bv::toggle::collapse', 'collapse-search');
      let isLiveStreamInfoOpen = this.isLiveInfoOpen;
      isLiveStreamInfoOpen = !isLiveStreamInfoOpen;
      this.$store.commit('setLiveStreamInfoState', isLiveStreamInfoOpen);
    },

    getPlayingNow() {
      this.$store.dispatch('setLiveStreamInfoDataOne');
      this.$store.dispatch('setLiveStreamInfoDataTwo');
      this.$store.dispatch('setLiveStreamInfoDataThree');
    },

    volumeChange() {
      this.volumeAudio = this.volume * 0.01;
    },
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/components/_live-radio.scss';

.logo--bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: black;
  height: 30px;
  z-index: 1040;
}

.logo--bottom a {
  padding: 0 20px 0 20px;
}

.logo--bottom a img {
  width: 100px;
}

.text-red {
  color: red;
}

.radio--container > div:first-child {
  border-right: none;
  border-bottom: 1px solid white;
}

.radio-index {
  font-size: 18px;
  height: 25px;
}

.logo-stegi {
  transition: all 0.5s ease;
}

.logo-stegi:hover {
  opacity: 0.8;
  cursor: pointer;
}

.on-air {
  font-size: 12px;
  width: 45px;
  flex-shrink: 0;
}

.marquee-text {
  -webkit-box-flex: 1;
  -webkit-flex-grow: 1;
  flex-grow: 1;
  margin: 0 8px 0 0;
  text-align: left;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -moz-box-orient: vertical;
  -webkit-box-orient: vertical;
}

@media (min-width: 1200px) {
  .on-air {
    width: auto;
  }
  .radio--container > div:first-child {
    border-right: 1px solid white;
    border-bottom: none;
  }
  .player-1:hover {
    opacity: 0.8;
    cursor: pointer;
  }
  .player-1.radioOn:hover {
    opacity: 1;
    cursor: pointer;
    background-color: var(--artist-module-color);
    color: white;
  }
}

@media (max-width: 991px) {
  .fixed-bottom-mix {
    bottom: 0;
  }
  .logo--bottom {
    display: block;
  }

  .player-1:active {
    background: transparent !important;
  }

  @keyframes marquee {
    0% {
      opacity: 0;
      margin-left: 100%;
      transform: translateX(0%);
    }
    25% {
      opacity: 1;
    }
    100% {
      opacity: 1;
      margin-left: 0;
      transform: translateX(-100%);
    }
  }
  .marquee-text {
    animation: marquee 15s linear infinite;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    /* display: -webkit-box; */
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -moz-box-orient: vertical;
    -webkit-box-orient: vertical;
  }

  .marquee-container {
    overflow: hidden;
    position: relative;
  }
}

.show-data-widget {
  height: 60px;
}

.player-1 {
  font-size: 18px;
  color: black;
  line-height: 1;
  height: 50px;
  transition: all 0.5s ease;
  flex: 0 1 50%;
}

.player-1:active {
  background-color: var(--warp-purple);
}

.radioOn {
  background-color: whitesmoke;
  color: black;
}

.radioOff {
  background-color: var(--radio-on);
  color: white;
}

.live-now-btn > i:hover {
  color: white;
}
</style>
